import * as React from "react";
import { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { List, ListItem, ListItemText, Collapse } from "@mui/material";
import { useTranslate, useSidebarState, usePermissions } from "react-admin";
import { canAccess } from "src/enterprise/ra-rbac";

const HasSubmenuPermissions = (children):boolean=>{
    const {permissions} = usePermissions();
    if(!Array.isArray(children))
        children = [children];
    let hasPermission = false;
    for (const child of children) {
      const access = canAccess({
        permissions,
        action: 'list',
        resource: child?.props?.resource,
      })
      hasPermission ||= access;
    }
    return hasPermission;
}

export const SubMenu = (props: SubMenuProps) => {
  const {
    isDropdownOpen = false,
    primaryText,
    leftIcon,
    children,
    ...rest
  } = props;
  const translate = useTranslate();
  const [open] = useSidebarState();
  const [isOpen, setIsOpen] = useState(isDropdownOpen);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const hasPermissions = HasSubmenuPermissions(children);
  if (!hasPermissions) return null;

  return (
    <React.Fragment>
      <ListItem
        dense
        button
        onClick={handleToggle}
        sx={{
          paddingLeft: "1.125rem",
          color: "grey.500",
        }}
      >
        {leftIcon}
        <ListItemText
          inset
          disableTypography
          primary={typeof primaryText === 'string'
            ? translate(primaryText, { _: primaryText })
            : primaryText}
          sx={{
            paddingLeft: 1,
            fontSize: "1rem",
            color: "text.secondary",
          }}
        />
        {isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          component="div"
          disablePadding
          sx={
            open
              ? {
                  paddingLeft: "25px",
                  transition:
                    "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
                }
              : {
                  paddingLeft: 0,
                  transition:
                    "padding-left 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
                }
          }
        >
          {children}
        </List>
      </Collapse>
    </React.Fragment>
  );
};

export type SubMenuProps = {
  children?: React.ReactNode;
  isDropdownOpen?: boolean;
  leftIcon?: React.ReactElement;
  primaryText?: string;
};

export default SubMenu;
